<template><div><h1>VUX V2.1.0Rc.46 released</h1>
<h2><a href="/en/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[feature] add more `less` variables #896 @erguotou520</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul></ul>
<h2><a href="/en/components/tab.html">Tab</a></h2>
<ul><li>[feature] add prop:bar-active-color #715 @greedying</li>
</ul>
<h2><a href="/en/components/x-button.html">XButton</a></h2>
<ul></ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul></ul>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[enhance] use `svg` for `+` `-` symbols</li>
<li>[feature] support `round` style for buttons</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.1.0Rc.46 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.0-rc.46-67.vue?529a7365